var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[_c('nav2',{on:{"load-menu":_vm.onLoadMenu}}),_c('div',{staticClass:"vc-page"},[_c('menu2',{ref:"menu2"}),_c('div',{staticClass:"vc-main"},[_c('div',{staticClass:"vc-main-content"},[_c('breadcrumb'),_c('div',{staticClass:"vc-wrapper vc-content"},[_c('router-view')],1)],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }